import { Component, ElementRef, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-content',
  templateUrl: './content.component.html',
  host: {
    class: 'uex-card-body card-body'
  }
})
export class CardContentComponent implements OnInit {
  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
